import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PartnerService } from '@principle-theorem/ng-principle-shared';
import { Partner } from '@principle-theorem/principle-core';
import {
  IPartner,
  isPartner,
  type IUser,
} from '@principle-theorem/principle-core/interfaces';
import {
  doc,
  Firestore,
  isWithRef,
  type ResolverResult,
  type WithRef,
} from '@principle-theorem/shared';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class PartnerUserResolver {
  constructor(private _partner: PartnerService) {}

  resolve(
    activatedRoute: ActivatedRouteSnapshot
  ): ResolverResult<WithRef<IUser>> {
    const uid: string = activatedRoute.paramMap.get('uid') || '';
    const routePartner = activatedRoute.parent?.data.partner as unknown;
    return this._partner.partner$.pipe(
      switchMap((partner) => {
        const resolvedPartner = partner || routePartner;
        if (!resolvedPartner) {
          throw new Error(`Can't find parent route`);
        }

        if (
          !isPartner(resolvedPartner) ||
          !isWithRef<IPartner>(resolvedPartner)
        ) {
          throw new Error(`Can't find partner`);
        }

        return Firestore.getDoc(doc(Partner.userCol(resolvedPartner), uid));
      })
    );
  }
}
